import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Label from '../../Fields/Label/Label';
import { getClassName } from '../../../utils/InputValidation';
import './BetsInput.scss';
import { styles } from '../formStyles';

const renderBetsInput = ({
  optional,
  autoFocus,
  placeholder,
  input,
  name,
  label,
  type,
  meta: { touched, invalid, visited, error, },
  customClass,
}) => {
  const showErrorMessage = (touched && invalid);
  const classes = useStyles();
  const inputWrapperClasses = classNames('input-wrapper', customClass);
  return (
    <div className={`${inputWrapperClasses} ${classes.betsInput}`}>
      {label &&
        <Label
          optional={optional}
          name={name}
          label={label}
          labelStyle={{ color: '#54515A', fontSize: '14px', fontWeight: '500', }}
        />
      }
      <span className={classes.euroSign}>&euro;</span>
      <input
        {...input}
        placeholder={placeholder}
        autoFocus={autoFocus}
        type={type}
        className={getClassName(touched, invalid, visited)}
      />
      <div className={classes.errorBox} style={{ display: showErrorMessage ? 'block' : 'none', }}>
        {error}
      </div>
    </div>
  );
};

renderBetsInput.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  optional: PropTypes.bool,
  placeholder: PropTypes.string,
  hideMessages: PropTypes.bool,
  customClass: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
  }).isRequired,
};

renderBetsInput.defaultProps = {
  label: '',
  name: '',
  autoFocus: false,
  hideMessages: false,
  optional: false,
  placeholder: '',
};

const useStyles = createUseStyles({
  betsInput: {
    position: 'relative',
    marginBottom: '12px',
  },
  euroSign: {
    position: 'absolute',
    fontSize: '26px',
    top: '36px',
    right: '8px',
  },
  errorBox: {
    color: styles.colors.red,
    fontSize: '16px',
  },
});

export default renderBetsInput;
